module.exports = __webpack_public_path__ + "static/scrapbook1-fa2e674a808abc8239e6cef0855d4f50.png";